<form #reportForm="ngForm" (ngSubmit)="onConfirm()" novalidate>
  <h2 mat-dialog-title>Confirm Transplantation</h2>
  <mat-dialog-content>
    <div class="participant-info">
      <div class="info-row">
        <span class="label">{{ participant.type || 'Participant' }}:</span>
        <span class="value">{{ participant.enisNumber }}</span>
      </div>
      <div class="info-row" *ngIf="participantName">
        <span class="label">Name:</span>
        <span class="value">{{ participantName }}</span>
      </div>
      <div class="info-row" *ngIf="participant.center">
        <span class="label">Center:</span>
        <span class="value">{{ participant.center.name }}</span>
      </div>
    </div>

    <div class="warning-note">
      <strong>Note:</strong> This will mark the participant as transplanted. The participant will be set to historical status and removed from future matching.
    </div>

    <div class="form-fields">
      <mat-form-field>
        <mat-label>Transplantation Date</mat-label>
        <input
          matInput
          [matDatepicker]="transplantDatePicker"
          [(ngModel)]="transplantDate"
          name="transplantDate"
          placeholder="DD/MM/YYYY"
          required
        />
        <mat-datepicker-toggle matSuffix [for]="transplantDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #transplantDatePicker></mat-datepicker>
        <mat-error>Transplantation date is required</mat-error>
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="onCancel()">Cancel</button>
    <button
      mat-raised-button
      color="primary"
      type="submit"
      [disabled]="!isFormValid()"
    >
      Confirm Transplantation
    </button>
  </mat-dialog-actions>
</form>
